import React from 'react';
import { useResolution } from '../../contexts/ResolutionContext';

const NotificationToast = () => {
	const { message, messageType, clearMessage } = useResolution();

	if (!message) return null;

	const getIcon = () => {
		switch (messageType) {
			case 'error':
				return (
					<svg className='w-5 h-5 mr-2' fill='currentColor' viewBox='0 0 20 20'>
						<path
							fillRule='evenodd'
							d='M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z'
							clipRule='evenodd'
						/>
					</svg>
				);
			case 'success':
				return (
					<svg className='w-5 h-5 mr-2' fill='currentColor' viewBox='0 0 20 20'>
						<path
							fillRule='evenodd'
							d='M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z'
							clipRule='evenodd'
						/>
					</svg>
				);
			case 'info':
			default:
				return (
					<svg className='w-5 h-5 mr-2' fill='currentColor' viewBox='0 0 20 20'>
						<path
							fillRule='evenodd'
							d='M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z'
							clipRule='evenodd'
						/>
					</svg>
				);
		}
	};

	const getColorClasses = () => {
		switch (messageType) {
			case 'error':
				return 'bg-red-50 border-red-500 text-red-700';
			case 'success':
				return 'bg-green-50 border-green-500 text-green-700';
			case 'info':
			default:
				return 'bg-blue-50 border-blue-500 text-blue-700';
		}
	};

	return (
		<div
			className={`fixed top-4 right-4 z-50 p-4 rounded-lg shadow-lg border-l-4 ${getColorClasses()} min-w-80 max-w-md`}
		>
			<div className='flex items-center justify-between'>
				<div className='flex items-center'>
					{getIcon()}
					<span className='text-sm font-medium'>{message}</span>
				</div>
				<button onClick={clearMessage} className='ml-4 text-gray-400 hover:text-gray-600'>
					<svg className='w-4 h-4' fill='currentColor' viewBox='0 0 20 20'>
						<path
							fillRule='evenodd'
							d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
							clipRule='evenodd'
						/>
					</svg>
				</button>
			</div>
		</div>
	);
};

export default NotificationToast;
